export default __webpack_public_path__ + "static/media/logo.12d612f4.svg";